import { PublicClientApplication } from '@azure/msal-browser';
import msalConfig from './config';

// Initialize the authentication
const msalInstance = new PublicClientApplication(msalConfig);

export default msalInstance;
